import { render, staticRenderFns } from "./ServiceAnalyticsSubjectTutorLoadGraph.vue?vue&type=template&id=573ee9e3&"
import script from "./ServiceAnalyticsSubjectTutorLoadGraph.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceAnalyticsSubjectTutorLoadGraph.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports